/** Cloudflare Turnstile — https://dash.cloudflare.com → Turnstile → crear widget (modo invisible). */
export function turnstileSiteKey(): string | undefined {
  const k = import.meta.env.VITE_TURNSTILE_SITE_KEY;
  return k && String(k).trim() ? String(k).trim() : undefined;
}

export function isTurnstileConfigured(): boolean {
  return Boolean(turnstileSiteKey());
}
